import FileSystem from "./FileSystem";
export default class SVGPath {
    constructor(xOffset, yOffset, width, height, svgPath) {
        this._xOffset = xOffset;
        this._yOffset = yOffset;
        this._width = width;
        this._height = height;
        this.svgPath = svgPath;
        this.length = this.getLength();
    }
    get viewBox() {
        return " " + this._xOffset + " " + this._yOffset + " " + this._width + " " + this._height;
    }
    static LoadFromFile(filePath) {
        if (SVGPath.Cache.has(filePath) === false) {
            const fileContent = FileSystem.ReadFile(filePath);
            const xmlFile = FileSystem.ConvertToXML(fileContent);
            const viewBox = SVGPath.GetViewBox(xmlFile);
            const path = SVGPath.GetPath(xmlFile);
            const transform = SVGPath.GetTranslation(xmlFile);
            viewBox[0] = viewBox[0] - transform[0];
            viewBox[1] = viewBox[1] - transform[1];
            let returned = new SVGPath(...viewBox, path);
            SVGPath.Cache.set(filePath, returned);
        }
        return SVGPath.Cache.get(filePath);
    }
    static GetViewBox(xmlFile) {
        let svg = xmlFile.getElementsByTagName("svg");
        console.assert(svg.length > 0);
        let viewport = svg[0].getAttribute("viewBox");
        return viewport.split(" ").map(s => Number(s));
    }
    static GetPath(xmlFile) {
        let path = xmlFile.getElementsByTagName("path");
        console.assert(path.length > 0);
        return path[0].getAttribute("d");
    }
    static GetTranslation(xmlFile) {
        let g = xmlFile.getElementsByTagName("g");
        if (g.length === 0)
            return [0, 0];
        let transform = g[0].getAttribute("transform");
        if (transform === null || transform.includes("translate(") === false)
            return [0, 0];
        let values = transform.split("translate(")[1].split(")")[0].split(",");
        return values.map(s => Number(s));
    }
    getLength() {
        var tag = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        tag.setAttributeNS(null, "viewBox", this.viewBox);
        var path = document.createElementNS('http://www.w3.org/2000/svg', "path");
        path.setAttributeNS(null, "d", this.svgPath);
        return path.getTotalLength();
    }
}
SVGPath.Cache = new Map();
